<template>
  <section
    :class="[
      'user-list-wrapper',
      type,
      fissionGame,
      showPaymentStatus ? '' : 'only-register',
    ]"
  >
    <div :class="['status-tips-wrapper', type]">
      <span class="finished login">{{ $t('fission.has-registered') }}</span>
      <span class="finished payment" v-show="showPaymentStatus">{{
        $t('fission.has-first-recharged')
      }}</span>
    </div>
    <ul :class="['user-list-body', type]">
      <!-- 已邀请人员列表 -->
      <li
        :class="['user-list-item', type]"
        v-for="item in dataSource"
        :key="item.toKicoinId"
      >
        <img
          class="user-avatar"
          :src="item.avatarUrl || defaultUrl"
          alt="logo"
        />
        <div class="status-tips-wrapper">
          <span
            :class="['login', item.registerStatus * 1 === 2 ? 'finished' : '']"
          ></span>
          <span
            v-show="showPaymentStatus"
            :class="['payment', item.payStatus * 1 === 2 ? 'finished' : '']"
          ></span>
        </div>
        <span class="award" v-if="item.payStatus * 1 === 2">
          {{ getAwards(item) }}</span
        >
      </li>
      <!-- 待邀请人数占位图 -->
      <li
        :class="['user-list-item', type, index === 0 ? 'pending' : '']"
        v-for="(item, index) in listToBeInvited"
        :key="index"
      >
        <div class="invitation">
          <span class="iconfont icon-add"></span>
        </div>
        <div class="status-tips-wrapper">
          <span class="login"></span>
          <span class="payment" v-show="showPaymentStatus"></span>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
  import { mapState } from 'vuex'
  import { textFormat } from '@/utils/pluralRules.js'

  export default {
    props: {
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      dataSource: {
        type: Array,
        default: () => [],
      },
      configs: {
        type: Object,
        default: () => {},
      },
      progressDatas: {
        type: Object,
        default: () => {},
      },
      awardList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        waitgingForInvitaionNumberArr: new Array(20),
        defaultUrl: require(`@/assets/images/common/icon/avatar.png`),
        textFormat: textFormat,
      }
    },
    computed: {
      ...mapState(['fissionGame']),
      registerAwardInfos() {
        // 新用户注册奖励,注册奖励可能配置了多个
        return (
          (this.awardList.filter((item) => item.conditionType * 1 === 3) ||
            [])[0] || {}
        )
      },
      registerAwardMaxCount() {
        // 计算拉新用户注册奖励封顶人数与最大奖励对应的图标
        let max = 0
        this.awardList.forEach((item) => {
          if (item.conditionType * 1 === 3) {
            if (item.conditionCount > max) {
              max = item.conditionCount
            }
          }
        })
        return max
      },
      paymentCappedBonus() {
        // 付费封顶奖励
        return (
          (this.awardList.filter((item) => item.conditionType * 1 === 5) ||
            [])[0] || {}
        )
      },
      showPaymentStatus() {
        return !(Object.keys(this.paymentCappedBonus).length === 0)
      },
      listToBeInvited() {
        // "firstPayCount": 仅首次付费用户数量
        // "registerCount": 仅新注册数量
        // "registerFirstPayCount": 新注册且首次付费用户数量
        const {
          registerCount = 0,
          firstPayCount = 0,
          registerFirstPayCount = 0,
        } = this.progressDatas || {}
        const { registerAwardMaxCount, paymentCappedBonus } = this
        const { conditionCount: paymentAwardMaxCount } =
          paymentCappedBonus || {}
        // 待注册的用户数
        const toBeRegisteredNum =
          registerAwardMaxCount - registerCount - registerFirstPayCount
        // 待付费的用户数
        const unpaidNum =
          paymentAwardMaxCount - firstPayCount - registerFirstPayCount
        // TODO: 是否要考虑未配置注册奖励的情况
        if (!paymentAwardMaxCount) {
          // 未配置最大付费封顶奖励
          return new Array(toBeRegisteredNum)
        } else {
          if (toBeRegisteredNum === 0 && unpaidNum === 0) {
            return new Array(0)
          } else {
            return new Array(Math.max(toBeRegisteredNum, unpaidNum))
          }
        }
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (!process.client) {
          return
        }
        // 第一个待邀请的dom需要自动滚动到可视区域的中部
        const pendingTarget = document.querySelector('.pending')
        const offsetLeft = pendingTarget && pendingTarget.offsetLeft
        const parentTarget = document.querySelector('.user-list-body')
        if (offsetLeft > window.innerWidth) {
          parentTarget &&
            parentTarget.scrollTo(offsetLeft - window.innerWidth / 2, 0)
        }
      })
    },
    methods: {
      getAwards(item) {
        const { payStatus } = item || {}
        const { extraInfo } = this.configs || {}
        const { splitActivityConditionList = [] } = extraInfo || {}
        const paymentedConfigInfos =
          (splitActivityConditionList.filter(
            (item) => item.conditionType * 1 === 4
          ) || [])[0] || {}

        const { awardCount: paymentAwards = 0, awardType } =
          paymentedConfigInfos

        if (payStatus * 1 === 2) {
          // awardType: 4为钻石，5为kgold
          if (awardType * 1 === 4) {
            return this.textFormat(this.$t('fission.diamonds'), paymentAwards)
          }
          if (awardType * 1 === 5) {
            return this.textFormat(this.$t('fission.kcoins'), paymentAwards)
          }
        }
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
